export enum ModalAction {
    "Continue" = "Continue",
    "GoBack" = "GoBack",
    "Dismiss" = "Dismiss",
}
